import React from 'react';
import {TableCell, TableRow, makeStyles} from '@material-ui/core';
import propTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  rowDivPictures: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 25,
    marginTop: 10,
    width: 'auto',
    maxWidth: '75%',
  },
  images: {padding: 5},
  assetThumbnail: {
    border: '1px solid white',
    '&:hover': {
      transform: 'scale(2.2)',
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
      transition: 'all .2s ease-in-out',
    },
  },
}));

const ImageThumbnailsRow = ({picturesToRender}) => {
  const classes = useStyles();
  const dataRevised = Array.isArray(picturesToRender) ? picturesToRender : [picturesToRender];
  if (dataRevised?.length) {
    return (
      <TableRow className={classes.rowDivPictures}>
        <TableRow>
          {dataRevised.map((item, index) => {
            if (item?.url) {
              return (
                <span className={classes.images} key={index}>
                  <img alt="" className={classes.assetThumbnail} src={item.url} width="150px" />
                </span>
              );
            }
            return null;
          })}
          <TableCell />
        </TableRow>
      </TableRow>
    );
  }
  return null;
};

export default ImageThumbnailsRow;

ImageThumbnailsRow.propTypes = {picturesToRender: propTypes.array};
